import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ConfirmationInput } from '@/shared/components/confirmation/confirmation.model';
import { ConfirmationModule } from '@/shared/components/confirmation/confirmation.module';
import { BaseComponent } from '@/shared/components/base/base.component';
import { CommonModule } from '@angular/common';
import { TypeModule } from '@virginmediao2/momentum-angular/components/text';
import { MarkdownModule } from 'ngx-markdown';
import { ButtonModule, IconModule, ModalModule, VmThemeProviderModule } from '@virginmediao2/momentum-angular';
import { environment } from '@/environment';
import { SESSION_KEY } from '@/shared/services';

@Component({
  selector: 'vm-which-tv-box',
  templateUrl: './which-tv-box.component.html',
  styleUrls: ['./which-tv-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    ConfirmationModule,
    IconModule,
    MarkdownModule,
    ModalModule,
    TypeModule,
    VmThemeProviderModule,
  ],
})
export class WhichTVBoxComponent extends BaseComponent {
  @Input() content: ConfirmationInput;
  @Input() workflowName: string;
  @Input() actionCode: string;
  
  strapiUrl = environment.strapi.image_url;
  isModalOpen = false;

  selectTVBox(url, selectedTVBoxType) {
    if (selectedTVBoxType) {
      this.sessionService.setData(SESSION_KEY.DIAGNOSTIC_FLOW, {
        ...this.sessionService.getData(SESSION_KEY.DIAGNOSTIC_FLOW),
        ...{ selectedTVBoxType, urlTVBoxType: `${selectedTVBoxType}/` },
      });
      const ses = this.sessionService.getData();
      if (url) {
        url = url.replace('<=df.urlTVBoxType>', ses.df.urlTVBoxType);
        this.toUrl(url);
      } else {
        this.toUrl(`/tv-error-codes/${this.workflowName}/${ses?.df?.urlDeviceType}${ses?.df?.urlActionCode}~initialise`);
      }      
    }    
  }

  openModal() {
    this.isModalOpen = true;
  }  

  closeModal() {
    this.isModalOpen = false;
  }  
}
